<template>
  <a-dialog ref="dialog" name="terminate_plan" :loading="loading" @open="opened" @close="$reset">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content" v-if="subscription">
      {{ $t('cancelation.date', { date: $helpers.present.date(subscription.period.end) }) }}

      <v-checkbox
        v-show="false"
        color="error"
        v-model="immediate"
        :label="$t('discount')">
      </v-checkbox>

      <v-alert class="mb-0" color="error" text border="left" v-if="immediate">
        {{ $t('warning') }}
      </v-alert>
    </div>
    <span slot="actions">
        <v-btn v-if="immediate" color="error" text @click="submit">{{ $t('actions.confirm') }}</v-btn>
        <v-btn v-else color="warning" text @click="submit">{{ $t('actions.confirm') }}</v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'TerminatePlanDialog',
  data () {
    return {
      subscription: null,
      loading: '',
      immediate: false
    }
  },
  methods: {
    opened (subscription) {
      this.subscription = subscription
    },
    async submit () {
      try {
        this.loading = this.$t('cancelation.saving')
        await this.subscription.terminate(this.immediate)

        this.loading = this.$t('cancelation.update')
        await this.$account.fetch()

        this.$ui.success(this.$t('cancelation.success'))
        if (this.$refs.dialog) this.$refs.dialog.close()
      } finally {
        this.loading = ''
      }
    }
  },
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"cancelation": {
			"date": "Are you sure you want to register the termination of your offer with the renewal date {date} ?",
			"saving": "Registration of your termination ...",
			"success": "Termination successfully registered.",
			"update": "Updating your subscription ..."
		},
		"discount": "I would like an immediate termination of my offer.",
		"title": "Cancel an offer",
		"warning": "Please note, immediate termination is instantaneous and does not entail any reimbursement of the remaining period."
	},
	"es": {
		"cancelation": {
			"date": "¿Está seguro de que desea registrar la rescisión de su oferta con la fecha de renovación {date} ?",
			"saving": "Registro de su rescisión ...",
			"success": "Rescisión registrada con éxito.",
			"update": "Actualizando su suscripción ..."
		},
		"discount": "Me gustaría una rescisión inmediata de mi oferta.",
		"title": "Cancelar una oferta",
		"warning": "Tenga en cuenta que la rescisión inmediata es instantánea y no implica ningún reembolso del período restante."
	},
	"fr": {
		"cancelation": {
			"date": "Souhaitez-vous réellement enregistrer la résiliation de votre offre à date de renouvellement le {date} ?",
			"saving": "Enregistrement de votre résiliation ...",
			"success": "Résiliation enregistrée avec succès.",
			"update": "Mise à jour de votre souscription ..."
		},
		"discount": "Je souhaite une résiliation immédiate de mon offre.",
		"title": "Résilier une offre",
		"warning": "Attention, une résiliation immédiate est instantanée et n'entraine aucun remboursement de la période restante."
	},
	"it": {
		"cancelation": {
			"date": "Sei sicuro di voler registrare la disdetta della tua offerta con la data di rinnovo il {date} ?",
			"saving": "Registrazione della tua disdetta ...",
			"success": "Disdetta registrata con successo.",
			"update": "Aggiornamento del tuo abbonamento ..."
		},
		"discount": "Desidero una disdetta immediata della mia offerta.",
		"title": "Annulla un'offerta",
		"warning": "Attenzione, una disdetta immediata è istantanea e non comporta alcun rimborso del periodo rimanente."
	},
	"pt": {
		"cancelation": {
			"date": "Tem a certeza de que deseja registar o cancelamento da sua oferta com a data de renovação {date} ?",
			"saving": "A registar o seu cancelamento ...",
			"success": "Cancelamento registado com sucesso.",
			"update": "A atualizar a sua subscrição ..."
		},
		"discount": "Gostaria de um cancelamento imediato da minha oferta.",
		"title": "Cancelar uma oferta",
		"warning": "Atenção, um cancelamento imediato é instantâneo e não implica qualquer reembolso do período restante."
	},
	"pl": {
		"cancelation": {
			"date": "Czy na pewno chcesz zarejestrować rozwiązanie oferty z datą odnowienia {date}?",
			"saving": "Rejestrowanie Twojego rozwiązania ...",
			"success": "Rozwiązanie pomyślnie zarejestrowane.",
			"update": "Aktualizacja Twojej subskrypcji ..."
		},
		"discount": "Chciałbym natychmiastowego rozwiązania mojej oferty.",
		"title": "Anuluj ofertę",
		"warning": "Uwaga, natychmiastowe rozwiązanie jest nieodwołalne i nie wiąże się z żadnym zwrotem za pozostały okres."
	}
}
</i18n>
